import React from "react";
import { Checkbox, FormControl, FormControlLabel } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import PropTypes from "prop-types";

function EditCheckbox(props) {
  const [value, setValue] = React.useState(props.value);

  const child = (write) => {
    return (
      <FormControl variant={"outlined"} size={"small"} fullWidth={props.fullWidth}>
        <FormControlLabel
          control={
            <Checkbox
              color={value !== props.value ? "secondary" : "primary"}
              checked={!!value}
              onClick={(e) => {
                e.stopPropagation();
              }}
              onChange={(e) => {
                setValue(e.target.checked);
                props.onChange(e.target.checked);
              }}
              disabled={!write || props.disabled}
              label={props.label}
              value={value}
            />
          }
          label={props.label}
          labelPlacement={props.labelPlacement ? props.labelPlacement : "top"}
        />
      </FormControl>
    );
  };

  const authWrapper = (child) => {
    return (
      <AuthorizationWrapper
        permission={props.authorizationField}
        child={(write) => {
          return child(write);
        }}
      />
    );
  };

  if (props.authorizationField) {
    return authWrapper(child);
  } else {
    return child(true);
  }
}

EditCheckbox.propTypes = {
  authorizationField: PropTypes.string,
  value: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default EditCheckbox;
